import dayjs from 'dayjs'

export const getDisplayName = (user) =>
    user?.userName ||
    user?.name ||
    [user?.firstName, user?.lastName].filter(Boolean).join(' ') ||
    '—'

export const getInitials = (user) => {
    const firstName = user?.firstName
    const lastName = user?.lastName
    if (firstName && lastName) {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
    }

    const fullName = getDisplayName(user)
    if (!fullName || fullName === '—') return '?'

    const parts = fullName.trim().split(/\s+/)
    if (parts.length >= 2) {
        return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase()
    }
    return parts[0].charAt(0).toUpperCase()
}

export const formatDate = (value) => {
    if (!value) return '—'
    const parsed = dayjs(value)
    return parsed.isValid() ? parsed.format('D MMM YYYY') : '—'
}

export const formatPhoneNumber = (phone) => {
    if (!phone) return ''

    const digits = String(phone).replace(/\D/g, '')
    if (!digits) return String(phone).trim()

    if (digits.length === 10) {
        return `${digits.slice(0, 5)} ${digits.slice(5)}`
    }

    if (digits.length > 6) {
        const leading = digits.length % 3 || 3
        const parts = [digits.slice(0, leading)]
        for (let index = leading; index < digits.length; index += 3) {
            parts.push(digits.slice(index, index + 3))
        }
        return parts.join(' ')
    }

    return digits
}

export const getPhoneParts = (record) => {
    if (!record?.phone) return null

    return {
        countryCode: record?.countryCode ? String(record.countryCode).trim() : '',
        number: formatPhoneNumber(record.phone),
    }
}

export const formatPhone = (record) => {
    const parts = getPhoneParts(record)
    if (!parts) return '—'
    return `${parts.countryCode ? `${parts.countryCode} ` : ''}${parts.number}`
}
